import { IPaginator } from 'models/paginator';

export interface IAuditLog {
  uniqueId: string;
  moduleUniqueId: string;
  module: string;
  eventTypeUniqueId: string;
  eventType: string;
  eventNameUniqueId: string;
  eventName: string;
  objectUniqueId: string;
  eventDate: string;
  authorUniqueId: string;
  authorFirstName: string;
  authorLastName: string;
  authorDisplayUniqueId: string;
  accountRoles?: string[];
}

export interface IAuditLogResponse extends IPaginator {
  content: IAuditLog[];
}

export interface IAuditLogSearchFormValues {
  accountsUniqueIds: string[];
  modulesUniqueIds: string[];
  eventTypesUniqueIds: string[];
  eventNamesUniqueIds: string[];
  eventDateFrom: string | Date;
  eventDateTo: string | Date;
}

export const initialAuditLogSearchValues: IAuditLogSearchFormValues = {
  accountsUniqueIds: [],
  modulesUniqueIds: [],
  eventTypesUniqueIds: [],
  eventNamesUniqueIds: [],
  eventDateFrom: '',
  eventDateTo: '',
};

interface IFilteredByObjectValue {
  [key: string]: any;
}

export interface IAuditLogItemResponse {
  accountLicenceAuthorities: string[];
  uniqueId: string;
  author: {
    uniqueId: string;
    email: string;
    phoneNumber: {
      codeDictionaryUniqueId: string;
      value: string;
    };
    firstName: string;
    lastName: string;
    displayUniqueId: string;
  };
  accountRoles?: string[];
  moduleUniqueId: string;
  module: string;
  eventTypeUniqueId: string;
  eventType: string;
  eventNameUniqueId: string;
  eventName: string;
  objectType: string;
  objectUniqueId: string;
  previousObjectValue: object | null;
  postObjectValue: object | null;
  filteredByObjectValue: IFilteredByObjectValue;
  eventDate: string | null;
  ipAddress: string;
  trustedDeviceName?: string;
}
